import React from "react";
import "./InterfaceSpec.css";

function InterfaceSpec({ topLabel, bottomLabel, centerLabel, active = false, onClick }) {
    return (
        <div
            className={`interface-spec-box${active ? " active" : ""}`}
            onClick={onClick}
        >
            <div>
                <div className="label-top">{topLabel}</div>
                <div className="label-bottom">{bottomLabel}</div>
            </div>
            <div className="label-center">{centerLabel}</div>
        </div>
    );
}

export default InterfaceSpec;